<div class="toolbar">
  <button matButton="text" [disabled]="isBusy()" (click)="backToPersonDetail()">
    <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
    <span>Back To Person</span>
  </button>
  <span class="spacer"></span>
  <h3 class="toolbarLabel">Delegations - {{ personName() }}</h3>
  <span class="spacer"></span>
</div>
@if (errorMessage()) {
  <div class="errorMessage">{{ errorMessage() }}</div>
}
<div class="wrapper">
  <div class="delegationListContainer">
    <div class="listToolbar">
      <span class="spacer"></span>
      <h3 class="toolbarLabel">Active Delegations</h3>
      <span class="spacer"></span>
      <button matButton="text" [disabled]="isBusy() || !personLogin()" (click)="newDelegation()">
        <mat-icon class="size-16">add</mat-icon>
        <span>Add</span>
      </button>
    </div>
    <table class="reportTable">
      <thead>
        <tr>
          <td class="tableCell headerCell centeredCell">Start Date</td>
          <td class="tableCell headerCell centeredCell">End Date</td>
          <td class="tableCell headerCell centeredCell">Delegate</td>
        </tr>
      </thead>
      <tbody>
        @for (delegation of activeDelegations(); track delegation.id) {
          <tr class="selectableRow" [class.selectedRow]="isSelected(delegation)" (click)="selectDelegation(delegation)">
            <td class="tableCell centeredCell">{{ formatDisplayDate(delegation.startTime) | date: 'MM/dd/yyyy' : 'UTC' }}</td>
            <td class="tableCell centeredCell">{{ formatDisplayDate(delegation.endTime) | date: 'MM/dd/yyyy' : 'UTC' }}</td>
            <td class="tableCell">{{ delegation.delegateDisplay }}</td>
          </tr>
        } @empty {
          <tr>
            <td colspan="3" class="tableCell">No active delegations</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  @if (selectedDelegation(); as delegation) {
    <div class="delegationDetail">
      <h3 class="detailHeader">Delegation Detail</h3>
      <div class="inputRow">
        <label class="inputLabel" for="delegateInput">Delegate</label>
        <select id="delegateInput" class="inputField" [ngModel]="delegation.delegate" (ngModelChange)="setDelegate($event)">
          <option [ngValue]="undefined" disabled>Please Select</option>
          @for (user of delegationUsers(); track user.code) {
            <option [ngValue]="user.code">{{ user.description }}</option>
          }
        </select>
      </div>
      <div class="inputRow">
        <label class="inputLabel">Start Date</label>
        <input [matDatepicker]="startTimePicker" [value]="formatDisplayDate(delegation.startTime)" (dateChange)="setStartTime($event.value)" />
        <mat-datepicker-toggle [for]="startTimePicker"></mat-datepicker-toggle>
        <mat-datepicker #startTimePicker></mat-datepicker>
      </div>
      <div class="inputRow">
        <label class="inputLabel">End Date</label>
        <input [matDatepicker]="endTimePicker" [value]="formatDisplayDate(delegation.endTime)" (dateChange)="setEndTime($event.value)" />
        <mat-datepicker-toggle [for]="endTimePicker"></mat-datepicker-toggle>
        <mat-datepicker #endTimePicker></mat-datepicker>
      </div>
      <div class="listToolbar">
        @if (delegation.id) {
          <button matButton="text" [disabled]="!canSave()" (click)="endNow()">
            <mat-icon class="size-16">report</mat-icon>
            <span>End Now</span>
          </button>
        }
        <span class="spacer"></span>
        <button matButton="text" [disabled]="isBusy()" (click)="cancelUpdate()">
          <mat-icon class="size-16">block</mat-icon>
          <span>Cancel</span>
        </button>
        <span class="spacer"></span>
        <button matButton="text" [disabled]="!canSave()" (click)="saveDelegation()">
          <mat-icon class="size-16">done</mat-icon>
          <span>Save</span>
        </button>
      </div>
    </div>
  }
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
